import { createAsyncThunk } from "@reduxjs/toolkit";
import { changePassword, login, logout } from "src/services/auth.service";
import { RootState } from "../store";
import { toast } from "sonner";
import { getAuthToken } from "../config";

// login
export const doLogin = createAsyncThunk(
  "auth/login",
  async (body: { email: string; password: string }, { rejectWithValue }) => {
    try {
    const response = await login(body);
      return response; 
    } catch (error: any) {
      console.error("Login Error:", error); 
      return rejectWithValue(error.response?.data?.message); 
    }
  }
);

// change password
export const doChangePassword = createAsyncThunk(
  "auth/changePassword",
  async (body: any, { getState, rejectWithValue }) => {
    const state = getState() as RootState;
    const accessToken = state.auth.token;
    if (!accessToken) {
      throw new Error("Authentication token not found");
    }
    try {
      const response: any = await changePassword(accessToken, body);
      return response;
    } catch (error: any) {
      toast.error(error.response.data.message)
      return rejectWithValue(
        error.response?.data?.message || "Failed to change password"
      );
    }
  }
);

// log out 
export const doLogout = createAsyncThunk(
  "auth/logout",
  async (_, { getState, rejectWithValue }) => {
    const state = getState() as RootState;
    const accessToken = getAuthToken();
    if (!accessToken) {
      return rejectWithValue("Authentication token not found");
    }

    try {
      const response: any = await logout(accessToken);
      if (response?.statusCode === 200) {
        toast.success("Logged out successfully");
        return response.message;
      } else {
        toast.error("Logout failed: Unexpected response");
        return rejectWithValue("Unexpected response from logout API");
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message || "Logout failed");
      return rejectWithValue(error?.response?.data?.message || "Logout failed");
    }
  }
);
